import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { digObject, toggleArray } from '@domain-group/javascript-utils'

import { DashboardModuleListItem, DashboardModule, Form } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

const allowedCampaignFields = [{ value: 'price', label: 'Price' }]

const updateRequiredCampaignFields = (value, requiredCampaignFields, updateServiceProduct, updateFn) => {
  const updatedRequiredCampaignFields = toggleArray(requiredCampaignFields, value)
  const updatedServiceProduct = { options: { required_campaign_fields: updatedRequiredCampaignFields } }

  const updateServiceProductPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: updatedServiceProduct,
    toastText: 'Product Updated',
  }

  updateServiceProduct(updateServiceProductPayload)
}

const confirmDelete = (field, requiredCampaignFields, updateServiceProduct, updateFn) => {
  swal
    .fire({
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes, delete it.',
      icon: 'warning',
      showCancelButton: true,
      text: 'Are you sure?',
      title: 'Remove Required Campaign Field?',
    })
    .then(({ value }) => {
      if (value){
        updateRequiredCampaignFields(field, requiredCampaignFields, updateServiceProduct, updateFn)
      }
    })
}

const CampaignField = (props) => {
  const { serviceProductPayload } = props

  const {
    callbacks: {
      updateServiceProduct: updateFn,
    },
    serviceProduct,
  } = serviceProductPayload

  const pageContext = useContext(PageContext)
  const {
    callbacks: { updateServiceProduct },
  } = pageContext

  const requiredCampaignFields = digObject(serviceProduct, 'options.required_campaign_fields', [])

  const filteredCampaignFields = allowedCampaignFields.filter(object => !requiredCampaignFields.includes(object.value))

  const showSelectBox = !!filteredCampaignFields.length

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Required Campaign Fields">
      {showSelectBox && (
        <Form>
          <Form.Field
            label="Campaign Field"
            boxProps={{ padding: 'large', paddingBottom: requiredCampaignFields.length ? 'medium' : null }}
          >
            <select
              onChange={e => (
                updateRequiredCampaignFields(e.target.value, requiredCampaignFields, updateServiceProduct, updateFn)
              )}
              value=""
            >
              <option value=""> Please Select... </option>
              {filteredCampaignFields.map(campaignField => (
                <option key={campaignField.value} value={campaignField.value}>{campaignField.label}</option>
              ))}
            </select>
          </Form.Field>
        </Form>
      )}

      {requiredCampaignFields.map((fieldKey) => {
        const fieldObject = allowedCampaignFields.find(object => object.value === fieldKey) || {}

        return (
          <DashboardModuleListItem title={fieldObject.label || fieldKey}>
            <DashboardModuleListItem.Actions>
              <DashboardModuleListItem.Icon
                onClick={() => {
                  confirmDelete(fieldKey, requiredCampaignFields, updateServiceProduct, updateFn)
                }}
                type="delete"
              />
            </DashboardModuleListItem.Actions>
          </DashboardModuleListItem>
        )
      })}
    </DashboardModule>
  )
}

CampaignField.propTypes = {
  serviceProductPayload: PropTypes.object.isRequired,
}

export default CampaignField
